import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IInvoiceItemTemplate, defaultValue } from '../../model/invoice-item-template.model';

export const ACTION_TYPES = {
  FETCH_INVOICEITEMTEMPLATE_LIST: 'invoiceItemTemplate/FETCH_INVOICEITEMTEMPLATE_LIST',
  FETCH_INVOICEITEMTEMPLATE: 'invoiceItemTemplate/FETCH_INVOICEITEMTEMPLATE',
  CREATE_INVOICEITEMTEMPLATE: 'invoiceItemTemplate/CREATE_INVOICEITEMTEMPLATE',
  UPDATE_INVOICEITEMTEMPLATE: 'invoiceItemTemplate/UPDATE_INVOICEITEMTEMPLATE',
  DELETE_INVOICEITEMTEMPLATE: 'invoiceItemTemplate/DELETE_INVOICEITEMTEMPLATE',
  SET_BLOB: 'invoiceItemTemplate/SET_BLOB',
  RESET: 'invoiceItemTemplate/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IInvoiceItemTemplate>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type InvoiceItemTemplateState = Readonly<typeof initialState>;

// Reducer

export default (state: InvoiceItemTemplateState = initialState, action): InvoiceItemTemplateState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE_LIST):
    case REQUEST(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_INVOICEITEMTEMPLATE):
    case REQUEST(ACTION_TYPES.UPDATE_INVOICEITEMTEMPLATE):
    case REQUEST(ACTION_TYPES.DELETE_INVOICEITEMTEMPLATE):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE_LIST):
    case FAILURE(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE):
    case FAILURE(ACTION_TYPES.CREATE_INVOICEITEMTEMPLATE):
    case FAILURE(ACTION_TYPES.UPDATE_INVOICEITEMTEMPLATE):
    case FAILURE(ACTION_TYPES.DELETE_INVOICEITEMTEMPLATE):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_INVOICEITEMTEMPLATE):
    case SUCCESS(ACTION_TYPES.UPDATE_INVOICEITEMTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_INVOICEITEMTEMPLATE):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/invoice-item-templates';

// Actions

export const getEntities: ICrudGetAllAction<IInvoiceItemTemplate> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE_LIST,
    payload: axios.get<IInvoiceItemTemplate>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IInvoiceItemTemplate> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_INVOICEITEMTEMPLATE,
    payload: axios.get<IInvoiceItemTemplate>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IInvoiceItemTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_INVOICEITEMTEMPLATE,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IInvoiceItemTemplate> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_INVOICEITEMTEMPLATE,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IInvoiceItemTemplate> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_INVOICEITEMTEMPLATE,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
